module.exports = __webpack_public_path__ + "img/list_Character_fluid_01.764731b7.jpeg";